<template>
  <div class="col mx-auto">
    <div class="row">
      <div class="col-12 col-md-7">
        <label class="wfh-label">Date Range</label>
        <div class="wfh-v-ctk-datepicker-override wfh-sm">
          <v-ctk-datepicker
              format="YYYY-MM-DD"
              formatted="YYYY-MM-DD"
              v-model="dateRange"
              :no-label="true"
              :only-date="true"
              :range="true"
          />
        </div>
      </div>
    </div>

    <div class="row align-content-center" style="min-height: 350px;" v-if="pageLoadReady && hasNoTasks">
      <div class="col-12 mx-auto text-center">
        <img src="/images/EmptyState.svg" alt="No Assigned Tasks">
      </div>
      <div class="col-12 mx-auto text-center mt-3">
        <div class="empty-state-title">No Task Yet</div>
        <p class="empty-state-description">
          Make sure to mark your task as completed once it is done.
        </p>
      </div>
    </div>

    <div class="row mt-4" style="min-height: 350px;" v-else>
      <div class="col-12 mx-auto p-0">
        <task-item v-for="(task, key) in tasks"
                   :isPersonal="true"
                   :key="key"
                   :task="task"
                   :viewOnly="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-auto mx-auto">
        <button
            class="btn wfh-btn-link-primary"
            :disabled="page >= lastPage || this.tasks.length === 0"
            @click="fetchNextTasks()"
        >
          Show More
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Task from '../../../Task/Task';
import { getCompletedDateRange, setCompletedDateRange } from '../../../../repositories/externalTasksStatePersistence';

export default {
  components: {
    getCompletedDateRange,
    setCompletedDateRange,
  },

  data () {
    return {
      tasks: [],
      page: 1,
      lastPage: 1,
      pageLoadReady: false,
      taskService: Task,
      dateRange: getCompletedDateRange() ?? {
        start: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      },
    };
  },

  computed: {
    hasNoTasks () {
      return this.pageLoadReady && this.tasks.length === 0;
    },
  },

  watch: {
    dateRange () {
      if ((this.dateRange !== null && this.dateRange.end !== null && this.dateRange.start !== null) ||
          this.dateRange === null) {
        setCompletedDateRange(this.dateRange);

        this.reset();
        this.fetchUserTasks();
      }
    },
  },

  methods: {
    toggleCheckbox (taskKey) {
      this.tasks = this.tasks.map((task, key) => {
        return key === taskKey ? {
          ...task,
          completed_at: !task.completed_at,
        } : task;
      });
    },

    reset () {
      this.tasks = [];
      this.page = 1;
      this.lastPage = 1;
      this.pageLoadReady = false;
    },

    fetchNextTasks () {
      this.page++;
      this.fetchUserTasks();
    },

    async fetchUserTasks () {
      const filters = {
        assigned_to: 'personal',
        type: 'todo',
        range: [this.dateRange.start, this.dateRange.end],
        status: 'completed',
        per_page: 15,
        page: this.page,
        for_external: true,
      };

      const res = await this.taskService.fetchTasks(filters);

      this.tasks = [...this.tasks, ...res.data];
      this.lastPage = res.last_page;
      this.pageLoadReady = true;
    },

    isCompleted (task) {
      return !!task.completed_at;
    },
  },

  mounted () {
    this.fetchUserTasks();
  },
};
</script>
